module.exports = __webpack_public_path__ + "img/tarj-cr-distri.039e4800.png";